"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Select = void 0;
const Select_1 = __importDefault(require("@material-ui/core/Select"));
const lib_palette_1 = __importDefault(require("@opsbase/lib-palette"));
const web_css_1 = __importDefault(require("@opsbase/web-css"));
const react_1 = __importStar(require("react"));
const MenuItem_1 = __importDefault(require("../MenuItem"));
const Text_1 = __importDefault(require("../Text"));
const makeMyClasses = (small, noBorder, white) => ({
    root: {
        paddingRight: small && noBorder
            ? '2px !important'
            : noBorder
                ? '0 !important'
                : small
                    ? '24px !important'
                    : undefined,
        paddingLeft: small && noBorder ? '2px !important' : small ? '8px !important' : undefined,
        paddingTop: small ? '4px !important' : undefined,
        paddingBottom: small ? '4px !important' : undefined,
        color: noBorder ? lib_palette_1.default.secondary.main : undefined,
        backgroundColor: white ? 'white !important' : undefined,
    },
    select: {
        fontSize: small ? '12px !important' : undefined,
    },
    icon: {
        top: small ? 0 : undefined,
        right: small ? '2px !important' : undefined,
        display: noBorder ? 'none' : undefined,
    },
});
function Select(props) {
    const { style, small = false, children, value = '', placeholder, label, disabled = false, white = false, autoFocus = false, fullWidth = false, multiple = false, onKeyUp, onChange, renderValue, onBlur, classes, noBorder = false, noMargin = true, } = props;
    const myCss = (0, web_css_1.default)(makeMyClasses, [small, noBorder, white], classes);
    return (0, react_1.useMemo)(() => (react_1.default.createElement(Select_1.default, { style: style, multiple: multiple, autoFocus: autoFocus, fullWidth: fullWidth, margin: noMargin ? 'none' : 'dense', classes: {
            root: myCss.root,
            select: myCss.select,
            icon: myCss.icon,
        }, disableUnderline: noBorder, disabled: disabled, label: label, variant: noBorder ? 'standard' : 'outlined', value: value || (placeholder ? 'placeholder' : ''), onKeyUp: onKeyUp, renderValue: renderValue, onChange: onChange ? e => onChange(e.target.value) : undefined, onBlur: onBlur ? e => onBlur === null || onBlur === void 0 ? void 0 : onBlur(e.target.value) : undefined },
        !!placeholder && (react_1.default.createElement(MenuItem_1.default, { value: "placeholder", disabled: true },
            react_1.default.createElement(Text_1.default, null, placeholder))),
        children)), [
        style,
        multiple,
        autoFocus,
        fullWidth,
        noMargin,
        myCss === null || myCss === void 0 ? void 0 : myCss.root,
        myCss === null || myCss === void 0 ? void 0 : myCss.select,
        myCss === null || myCss === void 0 ? void 0 : myCss.icon,
        noBorder,
        disabled,
        label,
        value,
        placeholder,
        onKeyUp,
        renderValue,
        onChange,
        onBlur,
        children,
    ]);
}
exports.Select = Select;
exports.default = Select;
